import { createSelector } from 'reselect'

export serviceExtras = (state, siteId, serviceArea) ->
  extras = state.serviceExtras[siteId] || {}
  return extras[serviceArea] if serviceArea && extras[serviceArea]
  return extras.main